import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

const DDEnabled = process.env.DD_RUM_ENABLED && process.env.DD_RUM_ENABLED === "true";

if (DDEnabled && process.env.DD_RUM_APP_ID && process.env.DD_RUM_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: process.env.DD_RUM_APP_ID,
    clientToken: process.env.DD_RUM_CLIENT_TOKEN,
    site: process.env.DD_RUM_SITE,
    service: process.env.DD_RUM_APP_NAME,
    env: process.env.DD_RUM_ENVIRONMENT,
    version: process.env.CI_COMMIT_SHORT_SHA,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
    allowedTracingUrls: [
      /https:\/\/axle\.teamworks(app|uat)\.(com|co\.nz|eu)/,
      /https:\/\/\w*.teamworks(app|uat)(.\w{2,3})?.\w*\/axle/,
    ],
  });

  datadogLogs.init({
    service: process.env.DD_RUM_APP_NAME,
    clientToken: process.env.DD_RUM_CLIENT_TOKEN,
    site: process.env.DD_RUM_SITE,
    env: process.env.DD_RUM_ENVIRONMENT,
    forwardErrorsToLogs: true,
  });
}
